// Helpers
import { dispatch } from "../../helpers/actions";

const UPDATE_PAGE_HEADER_TITLE = "UPDATE_PAGE_HEADER_TITLE";

export const pageActions = {
	UPDATE_PAGE_HEADER_TITLE,
	updatePageHeaderTitle: (payload: string) => dispatch(UPDATE_PAGE_HEADER_TITLE, payload)
};
